import axios from 'axios';
import interceptors from '../interceptors';

interceptors();

const baseUrl = '/marketplace/api';

export const authApi = {
  async getCurrentUser() {
    return await axios.get(`${baseUrl}/user`);
  },
  async login(data) {
    const res = await axios.post(`${baseUrl}/user/login`, data);

    const access_token = res.data.access_token;
    const refresh_token = res.data.refresh_token;
    delete res.data.access_token;
    delete res.data.refresh_token;
    const user = res.data;

    return {access_token, refresh_token, user};
  },
  async register(data) {
    const res = await axios.post(`${baseUrl}/user/register`, data);

    const access_token = res.data.access_token;
    const refresh_token = res.data.refresh_token;
    delete res.data.access_token;
    delete res.data.refresh_token;
    const user = res.data;

    return {access_token, refresh_token, user, newRegistration: true};
  },
  async forgotPassword(data) {
    const res = await axios.post(`${baseUrl}/user/forgot-password`, data);

    return res.data;
  },
  async resetPassword(data) {
    return await axios.post(`${baseUrl}/user/reset-password`, data);
  },
  async validate(data) {
    return await axios.post(`${baseUrl}/user/validate`, {email: data});
  },
  async refreshToken(_refresh_token) {
    const res = await axios.post(
      `${baseUrl}/user/refresh-token`,
      {refresh_token: _refresh_token}
    );

    return {
      access_token: res.data.access_token,
      refresh_token: res.data.refresh_token
    };
  },
  async logout(access_token, refresh_token) {
    await axios.post(
      `${baseUrl}/user/logout`,
      {access_token: access_token, refresh_token: refresh_token}
    );
  }
};
